//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

export default {
  name: '',
  data() {
    return {
      list_ary: [],
      form_up: {
        title: '',
        content: '',
        dialog: false
      },
      toast: {
        dialog: false,
        text: ""
      }
    }
  },
  mounted() {},
  components: {},
  methods: {
    ask_for_questions: function() {
      if (!localStorage.getItem("login_peo")) {
        this.toast_value = "请登录";
        this.show_toast = true;
        let timer = setTimeout(() => {
          this.$router.push({
            path: '/my',
          });
        }, 800);
        return;
      } else {
        this.form_up.dialog = true;
      }
    },
    onSubmit() { //提交数据

      if (this.form_up.title == "" || this.form_up.content == "") {
        this.toast.text = "信息不完整";
        this.toast.dialog = true;
        return;
      }

      this.$http.get('/upload/stu_upload.php', {
          params: {
            operate_type: 'up_question',
            name: JSON.parse(localStorage.getItem("login_peo")).stu_name,
            title: this.form_up.title,
            ctn: this.form_up.content
          }
        }).then((res) => {
          if (res.data.status == 1) {
            this.form_up.title = "";
            this.form_up.content = "";
          }
          this.toast.text = res.data.info;
          this.toast.dialog = true;
        })
        .catch((error) => {
          console.log(error);
        });
    },
    enter_youAsk_myAnswer() {
      if (localStorage.getItem("login_peo")) {
        this.$router.push({
          path: '/get_stu_up_question',
        });
      } else {
        this.toast_value = "请登录";
        this.show_toast = true;
        let timer = setTimeout(() => {
          this.$router.push({
            path: '/my',
          });
        }, 800);
        return;
      }
    }
  }
}



// WEBPACK FOOTER //
// ./src/components/online_answer/list_online_answer.vue